import { connect } from "react-redux";

import { redirect_to_backend_admin } from "./actions";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    redirectToBackendAdmin: (url) => {
      dispatch(redirect_to_backend_admin(url));
    },
  };
}

const backendAdminService = connect(mapStateToProps, mapDispatchToProps);
export default backendAdminService;
